module.exports = __webpack_public_path__ + "static/zamioculcas-zamiifolia-d7ced7393680583f38119dd33ee9e932.svg";